export interface Article {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  summary: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: number;
  tags: string[];
  relatedDramaIds: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-001',
    title: '2024年最值得追的十部国产剧，每一部都是精品',
    category: 'guochantuijian',
    categoryName: '国产推荐',
    summary: '2024年国产剧市场百花齐放，从古装权谋到都市情感，从悬疑推理到年代史诗，好剧层出不穷。我们为你精选了十部最值得追的国产剧。',
    content: `<p>2024年，中国电视剧市场迎来了前所未有的繁荣。从年初的《繁花》到年中的《庆余年2》，一部部精品国产剧不断刷新着观众的期待。</p>
    <h2>1. 《繁花》— 王家卫的上海传奇</h2>
    <p>王家卫导演首次执导电视剧，以其标志性的美学风格讲述了九十年代上海的商战故事。胡歌饰演的阿宝从一个普通青年成长为商界传奇，剧中的每一个镜头都如同一幅精美的画作。该剧播出后引发了全民讨论，豆瓣评分高达9.3分。</p>
    <h2>2. 《庆余年》第二季 — 范闲归来</h2>
    <p>时隔五年，备受期待的《庆余年》第二季终于上线。张若昀继续饰演范闲，在权谋与江湖中继续书写传奇。第二季在保持了第一季幽默风趣的同时，剧情更加紧凑，人物关系更加复杂。</p>
    <h2>3. 《狂飙》 — 年度现象级作品</h2>
    <p>如果要评选2023-2024年最具影响力的国产剧，《狂飙》当之无愧。张译和张颂文的精彩对决，展现了中国社会二十年的变迁。剧中"高启强"这个角色成为了一个文化符号。</p>
    <h2>4. 《漫长的季节》 — 东北悬疑天花板</h2>
    <p>辛爽导演继《隐秘的角落》后的又一力作。范伟、秦昊主演，讲述了一个跨越二十年的悬疑故事。剧中对东北老工业基地的刻画令人动容。</p>
    <h2>5. 《三体》 — 中国科幻的里程碑</h2>
    <p>刘慈欣的科幻巨著首次被搬上荧幕，虽然争议不断，但不可否认它为中国科幻电视剧开创了先河。宏大的宇宙观和深刻的人性思考令人印象深刻。</p>
    <h2>6. 《去有风的地方》 — 治愈系田园生活</h2>
    <p>刘亦菲和李现主演的这部田园治愈剧，以大理为背景，讲述都市人寻找自我的故事。美丽的云南风光和温暖的人情味，让这部剧成为了年度治愈担当。</p>
    <h2>7. 《莲花楼》 — 武侠剧的新探索</h2>
    <p>成毅、曾舜晞主演的古装武侠探案剧，将传统武侠与现代悬疑元素相结合，开创了武侠剧的新风格。精湛的打戏和烧脑的案件让观众欲罢不能。</p>
    <h2>8. 《长相思》 — 古装神话爱情</h2>
    <p>杨紫、张晚意主演的古装神话剧，改编自桐华同名小说。精美的服化道和虐心的剧情让它成为暑期档爆款。</p>
    <h2>9. 《新闻女王》 — 职场剧新标杆</h2>
    <p>佘诗曼主演的这部新闻行业剧，以快节奏的叙事和真实的职场描绘赢得了观众的好评。剧中展现了新闻工作者在理想与现实之间的挣扎。</p>
    <h2>10. 《故乡，别来无恙》 — 现实题材的温暖之作</h2>
    <p>四个女孩从北京回到成都生活的故事，温暖治愈又不失现实深度。对当代年轻人生活状态的精准刻画引发了广泛共鸣。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Top%20ten%20best%20Chinese%20TV%20drama%20collage%20concept%20with%20elegant%20minimalist%20design%20featuring%20traditional%20Chinese%20motifs%20and%20modern%20cinematic%20elements%20warm%20golden%20and%20deep%20red%20accents%20editorial%20layout%20style&width=1200&height=630&seq=article-cover-001&orientation=landscape',
    author: '星辰编辑',
    publishDate: '2024-07-15',
    readCount: 128560,
    tags: ['国产剧', '推荐', '2024', '剧单'],
    relatedDramaIds: ['drama-003', 'drama-002', 'drama-004'],
    featured: true,
  },
  {
    id: 'article-002',
    title: '深度解析《狂飙》：一部扫黑除恶的史诗级作品',
    category: 'juping',
    categoryName: '剧评',
    summary: '《狂飙》为何能成为现象级爆款？从人物塑造、叙事结构到社会意义，全方位解读这部年度最佳国产剧。',
    content: `<p>如果要问2023年最火的一部国产剧是什么，答案毫无疑问是《狂飙》。这部由徐纪周执导，张译、张颂文主演的扫黑除恶题材电视剧，在播出后引发了全民追剧的热潮。</p>
    <h2>人物塑造：高启强的"逆袭"之路</h2>
    <p>张颂文饰演的高启强是全剧最出彩的角色。从一个在市场卖鱼的底层小贩，到京海市最大的黑恶势力头目，高启强的转变并非一蹴而就。编剧巧妙地为这个反派角色安排了"合理化"的成长路径——每一次作恶都有一个看似"不得已"的理由。这种处理方式让观众在厌恶他的同时，又对他的命运产生了某种程度的共情。</p>
    <h2>叙事结构：二十年正邪较量</h2>
    <p>该剧采用了三段式的叙事结构：2000年、2006年和2021年。三个时间节点分别对应了中国社会发展的不同阶段，也让安欣与高启强之间的正邪较量有了更丰富的时代背景。</p>
    <h2>社会意义：扫黑除恶的时代注脚</h2>
    <p>《狂飙》不仅仅是一部电视剧，它更是中国扫黑除恶专项斗争的一个时代注脚。剧中展现的权力腐败、黑恶势力渗透基层等问题，都是中国社会真实存在的痛点。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Deep%20analysis%20of%20Chinese%20crime%20drama%20The%20Knockout%20editorial%20design%20with%20dramatic%20portraits%20of%20actors%20against%20urban%20Chinese%20cityscape%20at%20night%20intense%20moody%20lighting%20dark%20and%20gold%20color%20scheme&width=1200&height=630&seq=article-cover-002&orientation=landscape',
    author: '星辰影评',
    publishDate: '2024-06-20',
    readCount: 98520,
    tags: ['狂飙', '剧评', '国产剧', '深度解析'],
    relatedDramaIds: ['drama-002'],
    featured: true,
  },
  {
    id: 'article-003',
    title: '韩剧为何能持续风靡全球？从《鱿鱼游戏》到《黑暗荣耀》的成功密码',
    category: 'hangyeshidian',
    categoryName: '行业视点',
    summary: '从Netflix投资到韩国本土制作，解析韩剧在全球市场取得成功的核心要素与未来趋势。',
    content: `<p>近年来，韩剧在全球范围内的影响力持续攀升。从2019年的《爱的迫降》到2021年的《鱿鱼游戏》，再到2022年的《黑暗荣耀》，韩剧一次次地刷新着全球观众的观剧体验。</p>
    <h2>Netflix的全球化战略</h2>
    <p>Netflix自2015年进入韩国市场以来，已经投资了超过数十亿美元用于韩国内容制作。《鱿鱼游戏》的成功证明了本土化内容在全球市场的巨大潜力。</p>
    <h2>韩国本土的制作能力</h2>
    <p>韩国拥有世界级的影视制作体系。从编剧到导演，从演员到后期，韩国影视产业已经形成了完整且高效的生产链。</p>
    <h2>普世价值观的表达</h2>
    <p>韩剧成功的另一个关键因素是其对普世价值观的精准把握。无论是阶级矛盾、校园霸凌还是贫富差距，韩剧总能在本土故事中找到全球观众的共鸣点。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20global%20success%20concept%20design%20with%20iconic%20scenes%20from%20Squid%20Game%20and%20The%20Glory%20merged%20with%20world%20map%20and%20streaming%20platform%20symbols%20vibrant%20and%20modern%20editorial%20style&width=1200&height=630&seq=article-cover-003&orientation=landscape',
    author: '星辰观察',
    publishDate: '2024-05-10',
    readCount: 76340,
    tags: ['韩剧', '行业分析', 'Netflix', '全球市场'],
    relatedDramaIds: ['drama-009', 'drama-010'],
    featured: false,
  },
  {
    id: 'article-004',
    title: '《庆余年2》vs《繁花》：2024年国产剧的双子星对决',
    category: 'juping',
    categoryName: '剧评',
    summary: '两部顶级国产剧在同一年播出，一个古装权谋一个年代商战，谁才是年度最佳？从多个维度进行对比分析。',
    content: `<p>2024年的国产剧市场格外热闹。前有《繁花》横空出世，后有《庆余年2》强势回归。两部剧都取得了极高的收视和口碑，成为了当之无愧的年度爆款。</p>
    <h2>导演风格对比</h2>
    <p>王家卫的《繁花》充满了浓郁的个人风格。每一帧画面都经过精心雕琢，光影和色调的处理让人联想到他的经典电影作品。而孙皓导演的《庆余年2》则延续了第一季轻松诙谐的叙事风格，在紧张刺激的权谋斗争中穿插了大量幽默元素。</p>
    <h2>演员阵容对决</h2>
    <p>《繁花》汇集了胡歌、马伊琍、唐嫣、辛芷蕾等实力派演员。胡歌饰演的阿宝在不同时期的状态切换自如，展现了他作为演员的深厚功底。《庆余年2》则有张若昀、李沁、陈道明等演员加盟。陈道明的庆帝气场十足，每一个出场都令人印象深刻。</p>
    <h2>制作水准</h2>
    <p>两部剧在制作上都达到了国内顶级水准。《繁花》在上海搭建了1:1的黄河路实景，细节还原度令人惊叹。《庆余年2》则在前作基础上进一步提升了服化道和特效水平。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Split%20composition%20design%20showing%20two%20contrasting%20Chinese%20drama%20styles%20one%20side%20period%20ancient%20palace%20golden%20tones%20other%20side%201990s%20Shanghai%20neon%20vintage%20aesthetic%20editorial%20comparison%20layout&width=1200&height=630&seq=article-cover-004&orientation=landscape',
    author: '星辰编辑',
    publishDate: '2024-06-01',
    readCount: 89200,
    tags: ['庆余年2', '繁花', '国产剧', '对比评测'],
    relatedDramaIds: ['drama-003', 'drama-004'],
    featured: true,
  },
  {
    id: 'article-005',
    title: '追剧新手指南：如何高效追剧不浪费时间',
    category: 'zhuijugonglve',
    categoryName: '追剧攻略',
    summary: '掌握这些追剧技巧，让你在有限的时间里看到最优质的内容，告别追剧疲劳和选择困难症。',
    content: `<p>在信息爆炸的时代，每天都有大量的新剧上线。面对海量的内容选择，很多追剧爱好者都面临着一个共同的问题：如何高效地选择值得追的剧集？</p>
    <h2>第一步：明确你的观剧偏好</h2>
    <p>首先要清楚自己喜欢什么类型的剧。是烧脑悬疑还是轻松喜剧？是古装权谋还是现代都市？明确了偏好后，就可以有针对性地筛选剧集。</p>
    <h2>第二步：善用评分和评论</h2>
    <p>在决定追一部剧之前，可以先查看豆瓣评分和热门评论。一般来说，评分在8.0以上的剧集质量较为可靠。</p>
    <h2>第三步：合理规划追剧时间</h2>
    <p>建议采用"三集定律"：先看三集，如果三集之后仍然没有吸引力，建议果断弃剧。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20home%20TV%20watching%20setup%20with%20comfortable%20couch%20laptop%20and%20popcorn%20soft%20warm%20lighting%20minimalist%20modern%20living%20room%20with%20large%20screen%20showing%20cinematic%20content%20relaxed%20atmosphere&width=1200&height=630&seq=article-cover-005&orientation=landscape',
    author: '星辰攻略',
    publishDate: '2024-04-22',
    readCount: 45600,
    tags: ['追剧', '攻略', '技巧', '指南'],
    relatedDramaIds: [],
    featured: false,
  },
  {
    id: 'article-006',
    title: '琅琊榜播出九年，为何依然被称为"国产剧天花板"？',
    category: 'juping',
    categoryName: '剧评',
    summary: '距离《琅琊榜》首播已经过去九年，这部豆瓣评分高达9.5分的作品为何至今无人超越？',
    content: `<p>2015年9月19日，《琅琊榜》首播。九年过去了，这部剧依然是无数观众心中的"国产剧天花板"。豆瓣评分稳定在9.5分，超过80万人打分。</p>
    <h2>完美的剧本改编</h2>
    <p>《琅琊榜》改编自海宴的同名小说。编剧团队在保留原著精髓的基础上，对情节进行了合理的改编和优化，使得剧情更加紧凑有力。</p>
    <h2>精良的制作水准</h2>
    <p>从服化道到场景设计，从配乐到运镜，《琅琊榜》的制作水准至今仍是行业标杆。剧中的礼仪、服饰都经过了严格的历史考证。</p>
    <h2>深入人心的角色塑造</h2>
    <p>梅长苏、靖王、霓凰郡主、飞流……每一个角色都塑造得立体丰满。胡歌将梅长苏的病弱与智慧、坚韧与脆弱演绎得入木三分。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Nirvana%20in%20Fire%20Chinese%20drama%20tribute%20design%20with%20Hu%20Ge%20as%20Mei%20Changsu%20silhouette%20against%20ancient%20Chinese%20palace%20with%20falling%20snow%20poetic%20and%20dramatic%20atmosphere%20editorial%20layout&width=1200&height=630&seq=article-cover-006&orientation=landscape',
    author: '星辰经典',
    publishDate: '2024-04-10',
    readCount: 115230,
    tags: ['琅琊榜', '经典', '国产剧', '剧评'],
    relatedDramaIds: ['drama-015'],
    featured: true,
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (category: string): Article[] => {
  return articles.filter((a) => a.category === category);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getRelatedArticles = (articleId: string, limit: number = 3): Article[] => {
  const article = getArticleById(articleId);
  if (!article) return [];
  return articles
    .filter((a) => a.id !== articleId && a.category === article.category)
    .slice(0, limit);
};